import { registerActions } from "../actionRegistry";
/**
 * Interior Management Functions
 *
 * Functions for managing interior keywords, selection, and related UI.
 */

import { api } from "../api";
import { toastError } from "../ui/messages";
import { modal } from "../ui/modal";
import { getDomElement, setText, setHtml, setStyle, show, hide, queryAll } from "../utils/dom";

// Interior select mode (true while the user is multi-selecting cards); local to this module.
let i_select_active = false;

/**
 * Deselect all interior items
 */
export function deselectAllMockups(): void {
  for (const el of queryAll<HTMLInputElement>(".int-sel")) {
    const raw_id = el.id.replace("int-sel-hidden-", "");
    if (el.value === "1") {
      toggleMockupSelection(raw_id);
    }
  }
}

/**
 * Process selected interiors count
 */
export function processMockupSelection(): void {
  let int_count = 0;

  for (const el of queryAll<HTMLInputElement>(".int-sel")) {
    if (el.value === "1") {
      int_count++;
    }
  }

  setText("interior-selected-count", String(int_count));
  setText("interior-selected-s", int_count === 1 ? "" : "s");
  setStyle("interior-selected-buttons", "opacity", int_count > 0 ? "1" : "0.2");
}

/**
 * Handle interior card click — open edit modal or toggle selection
 */
export function mockupCardClick(id: string): void {
  if (!i_select_active) {
    modal("editinterior:" + id, "large");
  } else {
    toggleMockupSelection(id);
  }
}

/**
 * Toggle interior selection
 */
export function toggleMockupSelection(id: string): void {
  const el = getDomElement<HTMLInputElement>("int-sel-hidden-" + id);
  if (el) {
    if (el.value === "0") {
      el.value = "1";
      setHtml("int-sel-" + id, '<i class="far fa-check-square"></i>');
    } else {
      el.value = "0";
      setHtml("int-sel-" + id, '<i class="far fa-square"></i>');
    }
  }
  processMockupSelection();
}

/**
 * Toggle interior select mode
 */
export function applyMockupSelection(): void {
  if (!i_select_active) {
    i_select_active = true;
    setHtml("applyMockupSelection", '<i class="fas fa-check"></i> Done selecting');
    for (const item of queryAll<HTMLElement>(".int-sel-item")) {
      item.classList.add("int-sel-item-active");
    }
    show("interior-selected");
  } else {
    i_select_active = false;
    setHtml("applyMockupSelection", '<i class="fas fa-hand-pointer"></i> Select');
    for (const item of queryAll<HTMLElement>(".int-sel-item")) {
      item.classList.remove("int-sel-item-active");
    }
    hide("interior-selected");
  }
}

export async function deleteUserMockup(id: string): Promise<void> {
  if (!confirm("Are you sure you want to remove the interior?")) return;
  try {
    await api.mockups.deleteUser({ id });
    location.href = "/interiorengine";
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

registerActions({
  idesel: deselectAllMockups,
  intselprocess: processMockupSelection,
  intseltoggle: toggleMockupSelection,
  interiorCardClick: mockupCardClick,
  interiorselect: applyMockupSelection,
  deleteinterioruser: deleteUserMockup,
});
